<template>
  <transition name="fade">
    <div class="alert-holder" v-if="notification.show">
      <div :class="`elr-alert ${notification.className}`">
        <CloseButton @closed="dismiss" />
        {{notification.message}}
      </div>
    </div>
  </transition>
</template>

<script>
import CloseButton from '../CloseButton/CloseButton';

export default {
  name: 'Notification',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  components: {
    CloseButton
  },
  methods: {
    dismiss() {
      this.$emit('dismissAlert');
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/elr-scss-alerts/src/main';

.alert-holder {
  padding: 20px 0;
}

.elr-alert {
  @include elr-alert(
    $config: (
      border-radius: 3px
    )
  );
  margin: 10px auto;
  max-width: 768px;
}

.elr-alert-info {
  @include elr-alert-context(
    $config: (
      type: info
    )
  );
}

.elr-alert-danger {
  @include elr-alert-context(
    $config: (
      type: danger
    )
  );
}

.elr-alert-warning {
  @include elr-alert-context(
    $config: (
      type: warning
    )
  );
}

.elr-alert-success {
  @include elr-alert-context(
    $config: (
      type: success
    )
  );
}

.elr-alert-muted {
  @include elr-alert-context(
    $config: (
      type: muted
    )
  );
}
</style>

<style>
.elr-alert .close {
  padding: 0;
}
</style>

